import { useQuery } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
import { fetchJobRuns, fetchJobDefinitions } from './api';
import type { JobRunFilters } from './types';

export function useJobRuns(filters: JobRunFilters) {
  return useQuery({
    queryKey: keys.admin.jobRuns(filters as Record<string, unknown>),
    queryFn: () => fetchJobRuns(filters),
  });
}

/** The live job registry — drives the filter dropdown so it can never list a retired job. */
export function useJobDefinitions() {
  return useQuery({
    queryKey: keys.admin.jobDefinitions(),
    queryFn: fetchJobDefinitions,
    staleTime: 5 * 60 * 1000,
  });
}
